export function getConnectionObjectTypeId(connection) {
  return connection.scope.objectTypes.hubSpot.objectTypeId || undefined;
}